export default "__VITE_ASSET__Cb1RUwZ3__"